/**
 * @fileoverview The "Water today?" answer's card (B139; owner, 2026-10-31: "water needs a headline"; B152, 2 Nov: "otherwise
 * a text line stating no need"). WaterSection draws the headline (the server's water.question, in the group-heading
 * style) and, when the day names no water job, this card under it: one row in JobCard's own frame and tick-column grid, the droplet in the column, the answer at the cards'
 * title weight with "· Next: Fri" muted beside it, and the line and the finger test muted under.
 *
 * Drawn on every day that names no water job (water.jobKeys is empty); on a Yes day the water job's card is the
 * answer and this card is not drawn. Every word is the server's; colours are theme colours.
 *
 * Where: WaterSection, the first section under the Almanac.
 * API: none.
 * Words: none of its own.
 *
 * @module WaterCard
 */

import React from 'react';
import { Droplet } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { BriefWater } from '@/shared/api/todayBrief';
import { CARD, ROW } from './QuietCard';

/** What the card shows. */
export interface WaterCardProps {
  /** The brief's water: its answer is drawn (the question is the heading, drawn by WaterSection). */
  water: BriefWater;
}

/**
 * The water answer's card, or nothing when the brief carries no answer.
 *
 * @param props - WaterCardProps.
 */
export const WaterCard: React.FC<WaterCardProps> = ({ water }) => {
  const answer = water.answer;
  if (!answer) return null;
  return (
    <div className={CARD}>
      <div className={ROW}>
        <span className="-my-1.5 flex h-11 w-11 items-center justify-center" aria-hidden="true">
          <Droplet className="h-5 w-5 text-verdict-water" />
        </span>
        <div className="min-w-0 pt-0.5">
          <p className="text-[1.0625rem] font-semibold leading-snug text-foreground">
            {answer.text}
            {answer.next && <span className={cn('font-normal text-muted-foreground')}> · {answer.next.text}</span>}
          </p>
          {answer.line && <p className="mt-0.5 text-sm leading-snug text-muted-foreground">{answer.line.text}</p>}
          {answer.fingerTest && <p className="mt-0.5 text-sm leading-snug text-muted-foreground">{answer.fingerTest.text}</p>}
        </div>
      </div>
    </div>
  );
};
